import { constants } from "../utils/utils";

const baseUrl = `https://api.mapbox.com/geocoding/v5/mapbox.places`;
const params = `access_token=${constants.REACT_APP_MAPBOX_MAPS}&country=us&worldview=us&bbox=-124.848974%2C24.396308%2C-66.885444%2C49.384358&language=en`;

export const findPlaceFromQuery = async (searchQuery: string) => {
  const url = `${baseUrl}/${searchQuery}.json?${params}`;

  try {
    const result = await fetch(url);
    const data = await result.json();

    if (data.features && data.features.length > 0) {
      return data.features[0];
    }
    return "Place not found, please try another one";
  } catch (error) {
    return `Error ${error}`;
  }
};

export const fetchScores = async (lat: number, lng: number, apiKey: string) => {
  try {
    return await fetch(
      `${constants.REACT_APP_API_URL}/v1/us/ratings`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": apiKey,
        },
        body: JSON.stringify({
          type: "Feature",
          properties: {},
          geometry: { type: "Point", coordinates: [lng, lat] },
        }),
      }
    );
  } catch (e) {
    console.error(`Error fetching from the api: ${e}`);
    throw e;
  }
};
